import { useQuery } from 'react-query'
import { api } from '../../../../services/api'

const fetchClientes = async () => {
  const response = await api.get('/site/v2/cadastro-cliente/listar-clientes-apas')
  return response.data
}

export const useClientesQuery = (options = {}) => {
  return useQuery('clientes-apas', fetchClientes, {
    refetchOnWindowFocus: false,
    staleTime: 1000 * 60 * 5, // 5 minutos
    ...options,
  })
}
